export const TandC_EN_Trans = {
    title: "Terms & Conditions"
};

export const TandC_DE_Trans = {
    title: "Allgemeine Geschäftsbedingungen"
};


